/* import __COLOCATED_TEMPLATE__ from './escalate-conversation-operation.hbs'; */
/* RESPONSIBLE TEAM: team-workflows */

import type AppService from 'embercom/services/app-service';
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type { NodeSelection } from 'prosemirror-state';
import type CommandsResolver from 'embercom/lib/workflows/commands-resolver';
import { inject as service } from '@ember/service';

interface Args {
  commandsResolver: CommandsResolver;
  onUpdateNode: (state: Record<string, unknown>, selection?: NodeSelection) => void;
  closePopover: () => void;
}

export default class EscalateConversationOperation extends Component<Args> {
  @service declare appService: AppService;

  @action
  onUpdateNode(identifier: string): void {
    this.args.onUpdateNode({
      subjectIdentifier: identifier,
      attributeValueType: 'fin',
    });

    this.args.closePopover();
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Workflows::GraphEditor::NodeItems::Steps::FinCustom::AiPromptDataPopover::EscalateConversationOperation': typeof EscalateConversationOperation;
  }
}
